export const G_RECAPTCHA_CLIENT_ID = process.env.REACT_APP_G_RECAPTCHA_CLIENT_ID
